export default __webpack_public_path__ + "static/media/copy.851d97db.svg";